module.exports = __webpack_public_path__ + "static/img/12.b9e397d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/eng/12.png
// module id = 3GVa
// module chunks = 0